import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetMobileHeaderComponent } from '@ui';

@Component({
  imports: [BottomSheetMobileHeaderComponent],
  selector: 'avs-li-mobile-export-devices-sheet',
  standalone: true,
  templateUrl: './export-devices-sheet.component.html',
})
export class ExportDevicesSheetV2Component {
  private _bottomSheetRef = inject<MatBottomSheetRef<ExportDevicesSheetV2Component>>(MatBottomSheetRef);

  close(value?: 'csv' | 'json') {
    this._bottomSheetRef.dismiss(value);
  }
}
